import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("span", {
  "data-testid": "client-form-managing-country-label",
  class: "font-semibold"
}, "Managing Country", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock(_component_DataWrapper, {
    "data-testid": "client-form-managing-country-field",
    fontSize: 14,
    style: {"flex":"1"}
  }, {
    label: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_CustomDropdown, {
        class: "mt-2",
        placeholder: "Pilih Managing Country",
        customValueStyle: "text-sm",
        customOptionStyle: "text-sm",
        "data-testid": "client-form-managing-country-dropdown",
        options: _ctx.options,
        selectedItem: _ctx.selectedName,
        isLoading: _ctx.isLoading,
        isDisabled: _ctx.isDisabled,
        modelValue: _ctx.selectedValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedValue = $event))
      }, null, 8, ["options", "selectedItem", "isLoading", "isDisabled", "modelValue"])
    ]),
    _: 1
  }))
}